export const GET_REGISTER_LIST = "GET_REGISTER_LIST";
export const REGISTER_PROCESSING = "REGISTER_PROCESSING";
export const STOP_REGISTER_PROCESSING = "STOP_REGISTER_PROCESSING";
export const REGISTER_REQ_DATA_OBJECT = "REGISTER_REQ_DATA_OBJECT";
export const REGISTER_SUCCESS_USER_DATA = "REGISTER_SUCCESS_USER_DATA";
